import {
  ClientsRoute,
  ClientDetailsRoute,
  ClientsLayoutRoute,
} from '@modules/clients/presentation/routes';
import { AccountRoute, HomeRoute } from '@modules/core/presentation/v1/routes';
import { IdentityRoute } from '@modules/identity/presentation/routes';

import {
  BankApplicationsKanbanRoute,
  CasesLayoutRoute,
  CasesRoute,
  CaseCreationBankDocumentsRoute,
  CaseCreationBasicInfoRoute,
  CaseCreationSubmitApplicationsRoute,
  CaseCreationLayoutRoute,
  CaseCreationBankFormsRoute,
  CaseCreationSubmissionRootRoute,
  CaseCreationSelectBankProductsRoute,
  CaseCreationFillFormsRoute,
  CaseCreationVaultFillFormsRoute,
  CaseCreationBanksFillFormsRoute,
  CasesBackwardCompatibleRoute
} from '@modules/opportunities/presentation/routes';
import { createRouter } from '@tanstack/react-router';
import { DashboardRoute } from '@modules/dashboard/presentation/routes';
import { VaultConfigRoute } from '@modules/vault/presentation/v1/routes';
import {
  CreditsInfoRoute,
  CreditsLayoutRoute,
  CreditsRoute,
  PayoutsRoute,
  PrivacyPolicyRoute,
  TermsAndConditionsRoute,
  TutorialsRoute
} from '@modules/core/presentation/v2/routes';
import {
  BankProductsRoute, BankUpdatesRoute, DocumentsCenterRoute
} from '@modules/banks/presentation/v2/routes';
import {
  ProposalCreationBankProductsRoute,
  ProposalCreationClientAndMortgageRoute,
  ProposalCreationConfiguratorRoute,
  ProposalCreationRoute,
  ProposalEditableTemplateRoute,
  ProposalPreviewRoute,
  ProposalsLayoutRoute,
  ProposalsListRoute,
} from '@modules/proposals/presentation/routes';
import { rootRoute } from '@app/router/root';
import { layoutRoute } from '@app/router/layout';
import { ReferAndEarnLayoutRoute, ReferAndEarnListRoute } from '@modules/refer-and-earn/presentation/routes';

const routeTree = rootRoute.addChildren([
  // Needs forge provider without layout
  IdentityRoute,
  ProposalPreviewRoute,
  TermsAndConditionsRoute,
  VaultConfigRoute,
  PrivacyPolicyRoute,
  layoutRoute.addChildren([
    AccountRoute,
    CreditsLayoutRoute.addChildren([
      CreditsRoute,
      CreditsInfoRoute
    ]),
    ClientsLayoutRoute.addChildren([
      ClientsRoute,
      ClientDetailsRoute
    ]),
    HomeRoute,
    PayoutsRoute,
    TutorialsRoute,
    BankUpdatesRoute,
    BankProductsRoute,
    DocumentsCenterRoute,
    DashboardRoute,
    ProposalsLayoutRoute.addChildren([
      ProposalsListRoute,
      ProposalCreationRoute.addChildren([
        ProposalCreationClientAndMortgageRoute,
        ProposalCreationBankProductsRoute,
        ProposalCreationConfiguratorRoute,
        ProposalEditableTemplateRoute
      ])
    ]),
    CasesBackwardCompatibleRoute,
    CasesLayoutRoute.addChildren([
      CasesRoute,
      BankApplicationsKanbanRoute,
      CaseCreationLayoutRoute.addChildren([
        CaseCreationBasicInfoRoute,
        CaseCreationBankDocumentsRoute,
        CaseCreationFillFormsRoute.addChildren([
          CaseCreationVaultFillFormsRoute,
          CaseCreationBanksFillFormsRoute
        ]),
        CaseCreationSubmissionRootRoute.addChildren([
          CaseCreationSelectBankProductsRoute,
          CaseCreationBankFormsRoute,
          CaseCreationSubmitApplicationsRoute
        ])
      ])
    ]),
    ReferAndEarnLayoutRoute.addChildren([
      ReferAndEarnListRoute
    ])
  ])
]);

export const router = createRouter({ routeTree });
